import { render } from "./PackageOrderFormModal.vue?vue&type=template&id=461891aa&scoped=true"
import script from "./PackageOrderFormModal.vue?vue&type=script&lang=js"
export * from "./PackageOrderFormModal.vue?vue&type=script&lang=js"

import "./PackageOrderFormModal.vue?vue&type=style&index=0&id=461891aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461891aa"]])

export default __exports__